import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntClickOutsideDirective} from "./int-click-outside.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [
    IntClickOutsideDirective
  ],
  exports: [
    IntClickOutsideDirective
  ]
})
export class IntClickOutsideModule {}
